import PropertyImg from "@assets/svg/PropertyImg.svg?react";
import { t } from "i18next";
import CustomizedProgressBars from "../../../../pages/PropertiesManagement/Linking/Components/CustomizedProgressBars";
//import CustomizedProgressBars from "..//pages/PropertiesManagement/Linking/Components/CustomizedProgressBars";

import {
  PropertyItemRight,
  SyncingStatusText,
} from "../../../../pages/PropertiesManagement/Linking/Components/styles";

interface PropertyCardProps {
  title?: string;
  address?: string;
  image?: string;
  isSelected?: boolean;
  onSelect?: () => void;
  isSyncing?: boolean;
}

const PropertyCard = ({
  title = "شقة مميزة في النرجس",
  address = "42 شارع الأمير مقرن، المرسلات، الرياض",
  image,
  isSelected = false,
  onSelect,
  isSyncing = false,
}: PropertyCardProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "750px",
        border: isSelected ? "2px solid #5B3FFF" : "1px solid #21212613",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        backgroundColor: isSelected ? "#F8F7FF" : "transparent",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      onClick={onSelect}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div>
          {image ? (
            <img
              src={image}
              alt={title}
              style={{
                width: "168.12px",
                height: "115.99px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          ) : (
            <PropertyImg
              style={{
                width: "168.12px",
                height: "115.99px",
              }}
            />
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginRight: "3px",
            marginLeft: "3px",
          }}
        >
          <div>
            <span
              style={{
                fontWeight: 700,
                fontSize: "18px",
                color: "#331860",
                marginTop: "4px",
              }}
            >
              {title}
            </span>
          </div>

          <div>
            <span
              style={{
                fontWeight: 400,
                fontSize: "15px",
                color: "#625783",
                marginTop: "0px",
              }}
            >
              {address}
            </span>
          </div>
        </div>
      </div>
      {isSyncing ? (
        <div style={{}}>
          <PropertyItemRight>
            <SyncingStatusText>
              {t("PROPERTIES_MANAGEMENT.SYNCING_STATUS")}
            </SyncingStatusText>
            <CustomizedProgressBars fast />
          </PropertyItemRight>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default PropertyCard;
